module.exports = __webpack_public_path__ + "static/img/1.c944c28.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/zh/1.png
// module id = lV7x
// module chunks = 0